import { conditionalStream } from "./conditionalStream";
const levelMap = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
};
/**
 * Sends logs that are at or above the given minimum log level.
 */
export const minimumLevelStream = (minimumLevel) => conditionalStream((event) => levelMap[event.level] >= levelMap[minimumLevel]);
//# sourceMappingURL=minimumLevelStream.js.map